import { useCallback, useMemo, useState } from 'react';

/**
 * Which series (brands, products) a chart draws. The first `defaultCount` keys start on; the rest
 * start off. A series the user has switched keeps that choice even if the list of keys changes.
 */
export const useSeriesVisibility = (
  keys: string[],
  defaultCount: number
): { visibleKeys: string[]; toggle: (key: string) => void } => {
  const [choices, setChoices] = useState<Record<string, boolean>>({});

  const visibleKeys = useMemo(
    () => keys.filter((key, index) => choices[key] ?? index < defaultCount),
    [choices, defaultCount, keys]
  );

  const toggle = useCallback(
    (key: string) => {
      setChoices(previous => {
        const index = keys.indexOf(key);
        const current = previous[key] ?? index < defaultCount;
        return { ...previous, [key]: !current };
      });
    },
    [defaultCount, keys]
  );

  return { visibleKeys, toggle };
};
